export default __webpack_public_path__ + "static/media/apostar_icons_meineapotheke.ee9a9995.svg";